import Image from "next/image";

export const NoFilterPage = ({ message }: { message?: string }) => {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-y-6 px-6">
      <div automation-id="logo">
        <Image
          src="/logo-bi-nobaseline.svg"
          alt={"no-filter-data"}
          width={325}
          height={316}
        />
      </div>
      <div automation-id="no-filter-selected-message">
        {message ? message : "test string"}
      </div>
    </div>
  );
};
